export default __webpack_public_path__ + "static/media/diversity.7fa4713e.jpg";